<ll-titulo>Estadísticas</ll-titulo>
<loading-layout #loadingLayout>
    <estadistica-evaluacion-alumno [evaluacionId]="evaluacionId"></estadistica-evaluacion-alumno>
</loading-layout>
